
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-05dccc13&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Workflow.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./Workflow.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-05dccc13!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./Workflow.vue"),
  /* scopeId */
  "data-v-05dccc13",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/Workflow.vue
// module id = 212
// module chunks = 2